import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import SVG from 'react-inlinesvg';
import SolarPanel from '/images/advocacy/solar-panel.svg';
import SolarPanels from '/images/advocacy/solar-panels2.png';
import MegaphoneSuccess from '/images/advocacy/megaphone-success.svg';
import { copyFor } from 'config';
import { VoiceSupportCard } from 'pages/solar/components/voice-support-card';
import { AdvocacyShare } from 'pages/solar/components/advocacy-share';
import { StyledImage } from './advocacy-module.style';

interface Props {
  completedAdvocacyCampaign: CompletedAdvocacyCampaign;
  advocacyCampaign: AdvocacyCampaign;
  margin?: Margin;
  stateFullName: string;
  stateAbbreviation: string;
  hasAdvocacyCampaignSubmission: boolean;
  utilityAccountId: number;
}

const getCompletedCopy = copyFor('solar.completedCampaignCard');

// TODO refactor to fetch its own data
export const AdvocacyModule = (props: Props) => {
  const {
    advocacyCampaign,
    completedAdvocacyCampaign,
    margin,
    stateAbbreviation,
    stateFullName,
    hasAdvocacyCampaignSubmission,
    utilityAccountId,
  } = props;
  const numberOfSubmissions = advocacyCampaign?.numberOfSubmissions;
  const flag = useFlags();

  // If the most recent non-default campaign is completed, show the completed card
  if (completedAdvocacyCampaign) {
    const { message, title } = completedAdvocacyCampaign;
    const description = getCompletedCopy('description', { message });

    return (
      <AdvocacyShare
        description={description}
        icon={<SVG src={SolarPanel} height="58px" width="100px" />}
        margin={margin}
        shareCopy={getCompletedCopy('shareCopy')}
        socialShareCopy={getCompletedCopy('socialShareCopy')}
        title={title}
      />
    );
    // If the most recent campaign isn't completed, and the user has submitted, show the submission card
  } else if (hasAdvocacyCampaignSubmission) {
    const getSubmissionCopy = advocacyCampaign.isDefault
      ? copyFor('solar.submissionCard.default')
      : copyFor('solar.submissionCard.nonDefault');

    const description =
      numberOfSubmissions > 9
        ? getSubmissionCopy('description.over9', {
            numberOfSubmissions,
            stateAbbreviation,
            stateFullName,
          })
        : getSubmissionCopy('description.under10');

    const icon = advocacyCampaign.isDefault ? (
      <StyledImage src={SolarPanels} />
    ) : (
      <SVG src={MegaphoneSuccess} height="64px" width="100px" />
    );

    return (
      <AdvocacyShare
        description={description}
        icon={icon}
        margin={margin}
        shareCopy={getSubmissionCopy('shareCopy', {
          stateAbbreviation,
        })}
        socialShareCopy={advocacyCampaign.shareText}
        title={getSubmissionCopy('title')}
      />
    );
    // There is an active campaign, show the voice support card
  } else if (advocacyCampaign && flag.lbShowAdvocacyCampaign) {
    return (
      <VoiceSupportCard
        advocacyCampaign={advocacyCampaign}
        margin={margin}
        state={stateFullName}
        stateAbbreviation={stateAbbreviation}
        utilityAccountId={utilityAccountId}
      />
    );
    // There are no campaigns
  } else {
    return null;
  }
};
